import setting from '../setting.js'
export default class AppGeolocation {
  configure (config = {}) {
    this.options = config.app || {}
    this.Store = config.store || {}
    this.Router = config.router || {}
    this.geolocation = null
    this.geolocationAvailable = false
    this.setting = setting
    this.km = 10 // 10km
    // this.distance = this.km / 6370.997
    this.currentPosition = null
  }
  static install = (Vue, options) => {
    Object.defineProperty(Vue.prototype, '$appGeolocation', {
      get () { return this.$root._appGeolocation }
    })

    Vue.mixin({
      components: {
      },
      computed: {
      },
      data () {
        return {
        }
      },
      beforeCreate () {
        if (this.$options.appGeolocation) {
          this._appGeolocation = this.$options.appGeolocation
          this._appGeolocation.configure(options)
        }
      },
      created () {
        if (this._appGeolocation) {
          this._appGeolocation.init()
        }
      }
    })
  }

  // init
  init () {
    this.geolocation = 'geolocation' in this.options ? this.options.geolocation : {}
    this.geolocationAvailable = Object.keys(this.geolocation).length > 0
  }

  // getCurrentPosition
  getCurrentPosition () {
    return new Promise((resolve, reject) => {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve(position)
          },
          (error) => {
            reject(error)
          }
        )
      // Geolocation APIが使えない
      } else {
        reject(new Error('geolocation is not available'))
      }
    })
  }

  // 距離はkm、latとlonは度
  calculateSquarePosition (lat, lon, dist, bearing) {
    let pi = 3.14159265358979
    let latRad = lat * Math.PI / 180
    let lonRad = lon * Math.PI / 180
    let bearingData = bearing * Math.PI / 180
    let latRadSin = Math.sin(latRad)
    let latRadCos = Math.cos(latRad)

    // 地球の半径に対する距離の比率
    let distSin = Math.sin(dist)
    let distCos = Math.cos(dist)

    let xlatRad = Math.asin(
      latRadSin * distCos +
      latRadCos * distSin * Math.cos(bearingData)
    )

    let xlonRad = lonRad + Math.atan2(
      Math.sin(bearingData) * distSin * latRadCos,
      distCos - latRadSin * Math.sin(xlatRad)
    )

    // 緯度と経度を度単位の2要素配列として返す
    let xlat = xlatRad * 180 / pi
    let xlon = xlonRad * 180 / pi

    if (xlat > 90) xlat = 90
    if (xlat < -90) xlat = -90
    while (xlat > 180) xlat -= 360
    while (xlat <= -180) xlat += 360
    while (xlon > 180) xlon -= 360
    while (xlon <= -180) xlon += 360

    return [xlat, xlon]
  }

  // 距離はkm、緯度と経度は度
  getSquareAroundPoint (lat, lon, dist) {
    return [
      this.calculateSquarePosition(lat, lon, dist, 0), // north point
      this.calculateSquarePosition(lat, lon, dist, 90), // east point
      this.calculateSquarePosition(lat, lon, dist, 180), // south point
      this.calculateSquarePosition(lat, lon, dist, 270) // west point
    ]
  }

  /*
   * 最小緯度、最大緯度、最小経度、最大経度を持つ配列を含む配列を返す。
   * これらの点を定義する正方形が180度子午線を横切る場合は、そのような2つの配列が返す。
   * それ以外の場合は、そのような配列（別の配列内）が返す。
   */
  getMinMaxCoords (lat, lon) {
    return new Promise((resolve) => {
      let distAry = []
      let kmCnt = 1
      // 1kmずつ配列に保存する
      while (kmCnt <= this.km) {
        let s = this.getSquareAroundPoint(lat, lon, kmCnt / 6370.997)
        console.log('getSquareAroundPoint', s)
        // 西経が南経よりも大きい場合
        if (s[3][1] > s[1][1]) {
          // 180度子午線を横切った場合
          distAry.push([
            [s[2][0], s[0][0], s[3][1], 180],
            [s[2][0], s[0][0], -180, s[1][1]]
          ])
        } else {
          // 180度子午線を横切らなかった場合（通常の場合）
          distAry.push([
            [s[2][0], s[0][0], s[3][1], s[1][1]]
          ])
        }
        kmCnt++
      }
      resolve(distAry)
    })
  }
}



// WEBPACK FOOTER //
// ./src/service/AppGeolocation.js